import React from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
 
export const SidebarData = [
    {
        title: "OVERALL RISK DASHBOARD",
        path: "/ORDash",
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,

        subNav: [
            {
              title: "Overall Risk Grade",
              path: "/ORDash/ORRiskGrade",
            },
            {
              title: "Risk Grades by Scan Category",
              path: "/ORDash/ORRiskbycat",
            },
            {
              title: "Financial Risk Impact",
              path: "/ORDash/ORRiskfin",
            },
            {
                title: "Sensitive Dark Web Value",
                path: "/ORDash/ORDWValue",
              },
              {
                  title: "Ransomware Recovery Cost",
                  path: "/ORDash/RWRecovery",
              },
              {
                  title: "Breach Notification Cost",
                  path: "/ORDash/Breachcost",
              },
              {
                  title: "Residual Risk Cost",
                  path: "/ORDash/Residualcost",
              },
              {
                title: "Compliance Tracker",
                path: "/ORDash/Comptracker",
              },
              {
                title: "Security Program KPI",
                path: "/ORDash/ProgramKPI",
              },
              {
                title: "Target Risk Matrix",
                path: "/ORDash/Riskmatrix",
              },
              {
                title: "Risk Trend Chart",
                path: "/ORDash/Trendchart",
              },
              {
                title: "Scan Summaries",
                path: "/ORDash/Datascans",
              },
              {
                title: "Mitigation Plans",
                path: "/ORDash/Mitigationplans",
              },  
          ],
      },
      {
        title: "AGENT STATUS",
        path: "/Agentstatus",
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,  
    
      },
      {
        title: "DATA SCAN DASHBOARD",
        path: "/DSDash",
        iconClosed: <RiIcons.RiArrowDownSFill />,
        iconOpened: <RiIcons.RiArrowUpSFill />,  

        subNav: [ 

      {
        title: "Data Scan Risk Grade",
        path: "/DSDash/DSRiskGrade",
      },
      {
        title: "Data Scan Trend Chart",
        path: "/DSDash/DSTrendChart",
        },
      {
        title: "Top 5 Categories Searched",
        path: "/DSDash/DSTop5",
      },
      {
        title: "Top 10 Targets",
        path: "/DSDash/DSTop10",
      },
      {
        title: "Data Category Analysis ",
        path: "/DSDash/DSDatacat",
      },
      {
        title: "Active Data Scans ",
        path: "/DSDash/DSActivescans",
      },
      {
        title: "Last 5 Data Scans ",
        path: "/DSDash/DSLast5",
      },
      {
        title: "Scheduled Scans",
        path: "/DSDash/DSScheduledscans",
      },
      {
        title: "Mitigation Plans in Progress",
        path: "/DSDash/DSMitprogress",
      },
    ],
  },

  {
    title: "DATA SCAN SCHEDULE",
    path: "/DSSched",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  

    subNav: [ 
        {
            title: "Configure and Schedule a Scan",
            path: "/DSSched/DSSched",
        },
        {
            title: "Select Data Category",
            path: "/DSSched/DSSelectcat",
            },
        {
            title: "Select Agent and Targets",
            path: "/DSSched/DSSelectagent",
        },
        {
            title: "Scheduled Scans",
            path: "/DSSched/DSRunningscans",
        },
    ],
},

{
    title: "DATA SCAN IN PROGRESS",
    path: "/DSProgress",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  

    subNav: [ 
        {
            title: "Data Scans in Progress",
            path: "/DSProgress/DSProgress",
        },
        {
            title: "Live Scan Result Snapshot",
            path: "/DSProgress/DSSnapshot",
        },
    ],
},

{
    title: "DATA SCAN HISTORY",
    path: "/DSHistory",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  

    subNav: [ 
        {
            title: "Data Scan History",
            path: "/DSHistory/DSHistory",
        },
    ],
},

  {
    title: "VULNERABILITY SCAN DASHBOARD",
    path: "/VSDash",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
            title: "Vulnerability Scan Risk Grade",
            path: "/VSDash/VSRiskGrade",
        },
        {
            title: "Vulnerability Scan Trend Chart",
            path: "/VSDash/VSTrendChart",
        },
        {
            title: "Top 5 Categories Searched",
            path: "/VSDash/VSTop5",
        },
        {
            title: "Targets with Most Vulnerabilities",
            path: "/VSDash/VSTop10",
        },
        {
            title: "All Vulnerabilities",
            path: "/VSDash/VSAllvulnhosts",
        },
        {
            title: "Active Vulnerability Scans",
            path: "/VSDash/VSActivescans",
        },
        {
            title: "Last 5 Vulnerability Scans",
            path: "/VSDash/VSLast5",
        },
        {
            title: "Scheduled Scans",
            path: "/VSDash/VSScheduledscans",
        },
        {
            title: "Mitigation Plans in Progress",
            path: "/VSDash/VSMitprogress",
        },

    ],
  },
  {
    title: "VULNERABILITY SCAN SCHEDULE",
    path: "/VSSched",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
            title: "Schedule Vulnerability Scan",
            path: "/VSSched/VSSched",
        },
        {
            title: "Select an Agent",
            path: "/VSSched/VSAgent",
        },
        {
            title: "Select Targets",
            path: "/VSSched/VSTarget",
        },
        {
            title: "Review Scan Details",
            path: "/VSSched/VSSubmit",
        },

    ],
  },
  {
    title: "VULNERABILITY SCAN PROGRESS",
    path: "/VSProgress",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
  },
  {
    title: "VULNERABILITY SCAN HISTORY",
    path: "/VSHistory",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
            title: "Vulnerability Scan History",
            path: "/VSHistory/VSHistory",
        },
        {
          title: "Individual Scan Snapshot",
          path: "/VSHistory/VSSnapshot",
        },
        {
          title: "Host Vulnerability Summary ",
          path: "/VSHistory/VSSummary",
        },

    ],
  },

  {
    title: "VULNERABILITY PATCHING",
    path: "/VSPatchman",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
            title: "Vulnerability Patch Manager",
            path: "/VSPatchman/VSPatchman",
        },
        {
          title: "Root Cause Breakdown",
          path: "/VSPatchman/VSRootcause",
        },
        {
          title: "Patch Scheduler",
          path: "/VSPatchman/VSPatchsched",
        },
        {
          title: "Patch History",
          path: "/VSPatchman/VSPatchhist",
        },

    ],
  },

  {
    title: "VULNERABILITY LOOKUP",
    path: "/VSLookup",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

  },

  {
    title: "VULNERABILITY SCAN COMPARE",
    path: "/VSCompare",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

  },


  {
    title: "SECURE BASELINE DASHBOARD",
    path: "/SBDash",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
            title: "Secure Baseline Risk Grade ",
            path: "/SBDash/SBRiskGrade",
        },
        {
          title: "Scan Overview ",
          path: "/SBDash/SBOverview",
        },
        {
          title: "Top 5 Baselines",
          path: "/SBDash/SBTop5",
        },
        {
          title: "Secure Baseline Trend Chart",
          path: "/SBDash/SBTrendchart",
        },
        {
          title: "Top 10 Low Score Targets",
          path: "/SBDash/SBTop10",
        },
        {
          title: "OS List",
          path: "/SBDash/SBOSList",
        },
        {
          title: "Active Baseline Scans",
          path: "/SBDash/SBActivescans",
        },
        {
          title: "Last 5 Secure Baseline Scans",
          path: "/SBDash/SBLast5",
        },
        {
          title: "Scheduled Scans",
          path: "/SBDash/SBScheduledscans",
        },
        {
          title: "Mitigation Plans in Progress",
          path: "/SBDash/SBMitprogress",
        },
    ],
  },

  {
    title: "SECURE BASELINE SCHEDULE",
    path: "/SBSched",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  

    subNav: [ 
        {
            title: "Configure and Schedule a Scan",
            path: "/SBSched/SBSched",
        },
        {
            title: "Select Agent and Targets",
            path: "/SBSched/SBAgents",
        },
        {
            title: "Scheduled Scans",
            path: "/SBSched/SBScheduled",
        },
    ],
  },
  {
    title: "SECURE BASELINE IN PROGRESS",
    path: "/SBProgress",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  

    subNav: [ 
        {
            title: "Secure Baseline Scans in Progress",
            path: "/SBProgress/SBProgress",
        },
        {
            title: "Live Scan Result Snapshot",
            path: "/SBProgress/SBLive",
        },
    ],
},

{
    title: "SECURE BASELINE SCAN HISTORY",
    path: "/SBHistory",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  

  },
  {
    title: "SECURE BASELINE LOOKUP",
    path: "/SBlookup",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,  
  },
  {
    title: "COMPLIANCE",
    path: "/CPMan",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
          title: "Set Up AD Monitor",
          path: "/CPMan/CPMan",
        },
        {
          title: "AD Monitor Results",
          path: "/CPMan/CPADResults",
        },
        {
          title: "Microsoft Secure Score",
          path: "/CPMan/CPMSSecscore",
        },
        {
          title: "Secure Score Actions",
          path: "/CPMan/CPMSSecactions",
        },
        {
          title: "Risk Assessment Breakdown",
          path: "/CPMan/CPRiskassess",
        },
        {
          title: "Generate Reports",
          path: "/CPMan/CPReports",
        },

    ],
  },
  {
    title: "MITIGATION DASHBOARD",
    path: "/MITDash",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
          title: "Mitigation Overview",
          path: "/MITDash/MITDash",
        },
        {
          title: "Key Performance Indicators",
          path: "/MITDash/MITKeyperf",
        },
        {
          title: "Most Active Mitigation Plans",
          path: "/MITDash/MITActive",
        },

    ],
  },
  {
    title: "MITIGATION PLANNING",
    path: "/MITPlan",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

      {
        title: "Mitigation Planning",
        path: "/MITPlan/MITPlan",
      },
      {
        title: "Create a Mitigation Plan ",
        path: "/MITPlan/MITCreate",
      },
      {
        title: "Select Targets",
        path: "/MITPlan/MITTargets",
      },
      {
        title: "Sub-Mitigation Overview",
        path: "/MITPlan/MITSubplan",
      },
      {
        title: "Create Sub-Mitigation Plan",
        path: "/MITPlan/MITCreatesub",
      },

    ],
  },
  {
    title: "MITIGATION REVIEW",
    path: "/MITReview",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
          title: "Mitigation Review",
          path: "/MITReview/MITReview",
        },
        {
          title: "Individual Plan Review",
          path: "/MITReview/MITPlanreview",
        },

    ],
  },
  {
    title: "REPORT BUILDER",
    path: "/Reportbuilder",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,

  },
  {
    title: "DARK WEB",
    path: "/DWEnroll",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
 
    subNav: [

        {
          title: "Dark Web Enrollment",
          path: "/DWEnroll/DWEnroll",
        },
        {
          title: "Dark Web Monitor Result ",
          path: "/DWEnroll/DWResult",
        },

    ],
  },
  {
  title: "ADMIN USERS/DEPARTMENTS",
  path: "/ADUsers",
  iconClosed: <RiIcons.RiArrowDownSFill />,
  iconOpened: <RiIcons.RiArrowUpSFill />,

  subNav: [

      {
        title: "Add or Update Users",
        path: "/ADUsers/ADUsers",
      },
      {
        title: "User Management Form",
        path: "/ADUsers/ADUserform",
      },
      {
        title: "Existing Users",
        path: "/ADUsers/ADUserexist",
      },
      {
        title: "Built-in Departments",
        path: "/ADUsers/ADDepts",
      },
      {
        title: "Custom Departments",
        path: "/ADUsers/ADCustomdepts",
      },

  ],
},
{
title: "ADMIN TARGETS",
path: "/ADTargets",
iconClosed: <RiIcons.RiArrowDownSFill />,
iconOpened: <RiIcons.RiArrowUpSFill />,

subNav: [

    {
      title: "Target Management ",
      path: "/ADTargets/ADTargets",
    },
    {
      title: "Add New Target ",
      path: "/ADTargets/ADNewtarget",
    },
    {
      title: "Network Discovery ",
      path: "/ADTargets/ADNetdisco",
    },
    {
      title: "New Network Discovery Scans ",
      path: "/ADTargets/ADNewdisco",
    },

],
},
{
  title: "ADMIN AGENTS",
  path: "/ADAgents",
  iconClosed: <RiIcons.RiArrowDownSFill />,
  iconOpened: <RiIcons.RiArrowUpSFill />,
  
  subNav: [
  
      {
        title: "Agent Download",
        path: "/ADAgents/ADAgents",
      },
      {
        title: "Agent Prerequisites",
        path: "/ADAgents/ADPrereq",
      },
      {
        title: "Agent Installation",
        path: "/ADAgents/ADInstall",
      },
      {
        title: "Provision New Agent",
        path: "/ADAgents/ADProvision",
      },
      {
        title: "Update Existing Agent",
        path: "/ADAgents/ADUpdate",
      },
      {
        title: "Agent Status and Actions",
        path: "/ADAgents/ADStatus",
      },
      {
        title: "Agent Permissions",
        path: "/ADAgents/ADPerms",
      },
  
  ],
  },
  {
    title: "ADMIN GENERAL",
    path: "/ADSystem",
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    
    subNav: [
    
        {
          title: "System Configuration",
          path: "/ADSystem/ADSystem",
        },
        {
          title: "3rd Party Credentials",
          path: "/ADSystem/AD3rdparty",
        },
        {
          title: "Office 365",
          path: "/ADSystem/ADO365",
        },
        {
          title: "Google Cloud",
          path: "/ADSystem/ADGoogle",
        },
        {
          title: "Add New Regex",
          path: "/ADSystem/ADNewregex",
        },
        {
          title: "Update or Remove Regex",
          path: "/ADSystem/ADUpdateregex",
        },
        {
          title: "Add or Update Keywords",
          path: "/ADSystem/ADkeywords",
        },
        
    ],
    },  
    {
      title: "",
      path: "/ADSystem",
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      
      },  
];